import React from 'react';
import { useDynamicParameters } from 'context/DynamicParameters/DynamicParametersContext';
import classNames from 'classnames';
import { ItineraryTypes } from '../types';
import { SvgIcon } from 'ui/SvgIcon';
import VideoThumbnailIcon from '../icons/VideoThumbnail.component.svg';

interface iResponsiveBackgroundImageDivProps {
  upload: ItineraryTypes['ItineraryImageUploadOrThumbnail'];
  index: number;
  className?: string;
  imgClassName?: string;
  onClick?: (uploadIndex: number) => void; // if clicking the image does something
  overlayText?: string; // if we have overlay text, overlay it and show it
}

export const ItineraryImage = (props: iResponsiveBackgroundImageDivProps) => {
  const params = useDynamicParameters();
  const { ITINERARY_MANAGER_BASE_URL } = params.dynamicParameters;

  // Create srcset string
  const srcset = Object.entries(props.upload.sizes)
    .map(([size, details]) => `${ITINERARY_MANAGER_BASE_URL}/viewer/v1/media/${details.path} ${details.width}w`)
    .join(', ');

  // Use the small size as the default src
  const defaultSrc = props.upload.isVimeoThumbnail
    ? props.upload.sizes.s.path
    : `${ITINERARY_MANAGER_BASE_URL}/viewer/v1/media/${props.upload.sizes.s.path}`;

  const sizes = [
    `(max-width: 640px) ${props.upload.sizes.s.width}px`,
    `(max-width: 768px) ${props.upload.sizes.m.width}px`,
    `(max-width: 1024px) ${props.upload.sizes.l.width}px`,
    `(max-width: 1279px) ${props.upload.sizes.xl.width}px`,
  ].join(', ');

  return (
    <div
      onClick={() => {
        props.onClick && props.onClick(props.index);
      }}
      className={classNames(
        'relative bg-cover bg-center',
        {
          'cursor-pointer': props.onClick,
        },
        props.className
      )}
    >
      <img
        style={{
          backgroundImage: `url('${defaultSrc}')`,
        }}
        src={defaultSrc}
        srcSet={props.upload.isVimeoThumbnail ? undefined : srcset}
        sizes={props.upload.isVimeoThumbnail ? undefined : sizes}
        alt={props.upload.displayName}
        className={classNames('object-cover w-full h-full bg-cover bg-center', props.imgClassName)}
        loading="lazy"
      />

      {props.upload.isVimeoThumbnail && (
        <SvgIcon
          IconComponent={VideoThumbnailIcon}
          className="absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%] fill-none stroke-none"
        />
      )}

      {props.overlayText && (
        <span className="bg-black/50 w-full h-full absolute top-0 left-0 right-0 bottom-0">
          <span className="text-white font-hurmegeometric-sans text-14px underline absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%]">
            {props.overlayText}
          </span>
        </span>
      )}
    </div>
  );
};
